// extracted by mini-css-extract-plugin
export default {"root":"MainLayout_root__7j7hB","main":"MainLayout_main__hZEwM"};